import envConfig from '@hulu/env-config';
import axios from 'axios';

import { User } from '../../utils/user';

const baseAdminService = axios.create({
  baseURL: envConfig.REACT_APP_AD_MANAGER_API,
});

baseAdminService.interceptors.request.use(async (config) => {
  await User.checkIdToken();
  const { idToken } = User.getUserInfo();

  config.headers.Authorization = `Bearer ${idToken}`;

  return config;
});

export { baseAdminService };
